var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLoaderLifestylex = function SvgLoaderLifestylex(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#20C997",
    d: "M32.575 18.493a1.343 1.343 0 0 1 .11-2.194L57.508.242c1.32-.854 2.862.734 1.904 1.962L42.173 24.282a1.437 1.437 0 0 1-2.013.232z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C8599",
    d: "M32.602 43.46a1.342 1.342 0 0 1-.166-2.148l7.699-6.79a1.436 1.436 0 0 1 2.081.2l17.498 23.09c.933 1.232-.605 2.794-1.916 1.947z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#20C997",
    d: "M19.986 29.906h18.526L2.297 57.725c-1.288.99-2.982-.598-2.008-1.882z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C8599",
    d: "M.29 3.97c-.975-1.284.719-2.872 2.007-1.882l36.215 27.818H19.986z"
  })));
};
export default SvgLoaderLifestylex;